export const shopifyTheme = {
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, 'sans-serif'",
  pallette: {
    main: "red",
    black: {
      main: "#000000",
    },
    silver: {
      main: "#EBEBEB",
      light: "#4D536B",
      primary: "#6B7496",
      secondary: "#C6CBE2",
      dark: "#D8DCEB",
      text: "#667085",
      disabled: "#BED1D5",
      disabledText: "#707998",
      disabledBg: "#0000000a",
    },
    dark: {
      main: "#101828",
    },
    blue: {
      main: "#0A1338",
      primary: "#182353",
      light: "#40a9ff",
      secondary: "#3B5998",
      link: "#00AEEF",
      border: "#1877F2",
      top: "#C5FFFD",
    },
    white: {
      main: "#FFFFFF",
      primary: "#fafafa",
      light: "#f1fcff",
    },
    green: {
      main: "#00A560",
      primary: "#77B747",
      light: "#047B5D",
      secondary: "#035E4C",
      disabled: "#C9FFD6",
      chip: "#cdffcd",
      circle: "#007f00",
      dark: "#148757",
      tooltip: "#37b850",
      free: "#d0feda",
    },
    red: {
      main: "#EF4444",
      primary: "#EF4444",
      secondary: "#E22C2A",
      error: "#7F1D1D",
      light: "#fca5a5",
      border: "#ff4d4f",
      danger: "#ff775d",
    },
    orange: {
      main: "#ff6347",
    },
    violet: {
      light: "#E9D7FE",
      main: "#6941C6",
    },
    yellow: {
      main: "#a17c0b",
      secondary: "#FDF7E7",
      light: "#fffaeb",
      border: "#FBBC04",
    },
  },
  fontSizes: [12, 14, 16, 18, 24, 32, 36, 72, 96],
  space: [0, 4, 8, 16, 32, 64, 128, 256],

  buttons: {
    main: {
      color: "#FFFFFF",
      background: "#047B5D",
      radius: "8px",
      shadow:
        "0rem -.0625rem 0rem .0625rem rgba(12, 81, 50, .8) inset, 0rem 0rem 0rem .0625rem rgba(19, 111, 69, .8) inset, 0rem .03125rem 0rem .09375rem rgba(255, 255, 255, .251) inset;",

      hover: {
        background: "#035E4C",
        color: "#FFFFFF",
      },
    },

    secondary: {
      color: "#FFFFFF",
      background: "#303030",
      border: "transparent",
      radius: "8px",
      shadow:
        "0rem -.0625rem 0rem .0625rem rgba(0, 0, 0, .8) inset, 0rem 0rem 0rem .0625rem rgba(48, 48, 48, 1) inset, 0rem .03125rem 0rem .09375rem rgba(255, 255, 255, .25) inset;",

      hover: {
        background: "#1a1a1a",
        color: "#FFFFFF",
        border: "transparent",
      },
    },

    middle: {
      color: "#FFFFFF",
      background: "#047B5D",
      radius: "8px",
      shadow:
        "0rem -.0625rem 0rem .0625rem rgba(12, 81, 50, .8) inset, 0rem 0rem 0rem .0625rem rgba(19, 111, 69, .8) inset, 0rem .03125rem 0rem .09375rem rgba(255, 255, 255, .251) inset;",

      hover: {
        background: "#035E4C",
        color: "#FFFFFF",
      },
    },

    submit: {
      color: "#FFFFFF",
      background: "#047B5D",
      radius: "8px",
      shadow:
        "0rem -.0625rem 0rem .0625rem rgba(12, 81, 50, .8) inset, 0rem 0rem 0rem .0625rem rgba(19, 111, 69, .8) inset, 0rem .03125rem 0rem .09375rem rgba(255, 255, 255, .251) inset;",
      border: "#047B5D",

      hover: {
        background: "#035E4C",
        color: "#FFFFFF",
        border: "#035E4C",
      },

      focus: {
        background: "#047B5D",
        color: "#FFFFFF",
        border: "none",
      },

      disabled: {
        background: "#047B5D",
        color: "#FFFFFF",
        border: "#047B5D",
        opacity: "0.3",
      },
    },

    modalButton: {
      color: "#FFFFFF",
      background: "#047B5D",
      shadow:
        "0rem -.0625rem 0rem .0625rem rgba(12, 81, 50, .8) inset, 0rem 0rem 0rem .0625rem rgba(19, 111, 69, .8) inset, 0rem .03125rem 0rem .09375rem rgba(255, 255, 255, .251) inset;",
      border: "0",
      radius: "8px",

      reset: {
        background: "#303030",
        color: "#FFFFFF",
        shadow:
          "0rem -.0625rem 0rem .0625rem rgba(0, 0, 0, .8) inset, 0rem 0rem 0rem .0625rem rgba(48, 48, 48, 1) inset, 0rem .03125rem 0rem .09375rem rgba(255, 255, 255, .25) inset;",
        hover: {
          background: "#1a1a1a",
        },
      },

      hover: {
        background: "#035E4C",
        color: "#FFFFFF",
      },

      focus: {
        background: "#047B5D",
        color: "#FFFFFF",
        border: "none",
      },

      disabled: {
        background: "#047B5D",
        color: "#FFFFFF",
        opacity: "0.3",
      },
    },

    startHere: {
      background: "#047B5D",
      color: "#FFFFFF",
      border: "none",

      hover: {
        background: "#035E4C",
        color: "#FFFFFF",
        mainColor: "#FFFFFF",
        border: "none",
        borderColor: "transparent",
      },
    },
  },
};
